export enum OrbitRefundTransactionStep {
  CONFIRM,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  DONE,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  REJECTED_BY_THE_USER,
}
